import React, { useEffect, useState } from 'react';
import { Progress } from 'web-library';
import { candidateConfigQuery } from '../../../api/candidate/config';
import { usePostAuditViewProfile } from '../../../api-refactored/user/usePostAuditViewProfile';
import AdminProfileForm from './AdminProfileForm';
import { useAdminProfileDetails } from '../logic/useAdminProfileDetails';

const AdminProfileDetails = () => {
  const {
    formDefaultValues,
    updateAdminDetails,
    updateAdminDetailsApiStatus,
    updateAdminDetailsError,
    refetch,
  } = useAdminProfileDetails();

  const viewProfile = usePostAuditViewProfile();

  const [openWindow, setOpenWindow] = useState<boolean>();
  const { mutate } = candidateConfigQuery.useCheckWindowConfig(
    (res) => {
      setOpenWindow(res.data.openWindowPeriod);
    },
    () => null
  );

  useEffect(() => {
    viewProfile.mutate();
    mutate({
      configurationType: 'AMEND_PROFILE',
      examLevelCode: 'N.A.',
    });
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, []);

  if (!formDefaultValues) {
    return <Progress color="secondary" />;
  }

  return (
    <AdminProfileForm
      isHideEditButton={!openWindow}
      isDisableInputs={{
        statutoryName: true,
        userIdType: true,
        adminId: true,
        dateOfBirth: true,
        email: true,
        accountType: true,

        // contact numbers
        mobileCountryCode: false,
        mobileContactNumber: false,
      }}
      isDisableValidationForDisabledInputs
      formDefaultValues={formDefaultValues}
      onCallHandleSubmit={(formData) => updateAdminDetails(formData)}
      ApiButtonStatus={updateAdminDetailsApiStatus}
      submitError={updateAdminDetailsError}
      refetchProfileData={refetch}
    />
  );
};

export default AdminProfileDetails;
